@if (tableData.length) {
<div class="table-style founder">
  <p-table [value]="tableData?.result" [rows]="10" [tableStyle]="{ 'min-width': '50rem' }" [loading]="loading">
    <ng-template pTemplate="header">
      <tr>
        @for (col of cols; track $index) {
        <th [pSortableColumn]="col.field">
          <div class="max-content"> {{ col.header }}
            <!-- <app-sort-icon *ngIf="col.sortable" [column]="col.field" [activeColumn]="sorting.column"
                [activeDirection]="sorting.direction" (sort)="sort($event)"></app-sort-icon> -->
          </div>
        </th>
        }
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <!-- <tr [routerLink]="['.',data.id]"> -->
      <tr>
        <td>
          <div class="d-flex align-items-center gap-2 w-max">
            <div class="status">
              <span class="online"></span>
            </div>
            <div class="image">
              <img class="avatar avatar-lg" [src]="defaultAvatar" alt="">
              <!--  [src]="item.profileImageUrl ? fileServerUrl+item.profileImageUrl : defaultAvatar" /> -->
            </div>
            <div class="text">
              <div class="title">Bad grades and solutions <span class="tag">Grades</span></div>
              <div class="description">
                Hi everyone, We are going to talk about a noticeable topic that is grades and discuss in a ways that we
                can be improve it since...
              </div>
            </div>
          </div>
        </td>
        <td>
          <div class="max-width">
            {{ formatDate(data.date) }}
          </div>
        </td>

      </tr>

    </ng-template>
  </p-table>
</div>
}@else {
<div class="d-flex align-items-center justify-content-between">
  <svg-icon class="svg-w-100 mx-auto mb-4" src="/assets/Icons/new/time.svg" style="width: 150px;"></svg-icon>
</div>
<div class="soon-title text-center text-muted ">Coming soon!</div>
}